import { render, staticRenderFns } from "./PropertyPreview.vue?vue&type=template&id=7bb8f2a6&scoped=true&"
import script from "./PropertyPreview.vue?vue&type=script&lang=js&"
export * from "./PropertyPreview.vue?vue&type=script&lang=js&"
import style0 from "./PropertyPreview.vue?vue&type=style&index=0&id=7bb8f2a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb8f2a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
